import React from 'react';
import { TreeNode } from './TreeNode';

export type TreeDataProps = {
  key: string;
  id: string;
  path: string;
  title: string;
  collapsed: boolean;
  type: string;
  children: TreeDataProps[];
};

interface TreeProps {
  dataSource: TreeDataProps[];
  depth: number;
  selectedKey?: string;
  onSelect?: (value: TreeDataProps) => void;
  setCollapsed: (value: TreeDataProps) => void;
}

export function Tree({ dataSource, depth, onSelect, selectedKey, setCollapsed }: TreeProps) {
  return (
    <div className='tree'>
      {dataSource.map((item, index) => {
        return (
          <TreeNode
            setCollapsed={setCollapsed}
            isLastNode={index === dataSource.length - 1}
            depth={depth}
            key={item.id}
            dataSource={item}
            onSelect={onSelect}
            selectedKey={selectedKey}
          />
        );
      })}
    </div>
  );
}
